import {IndicateurModel} from './indicateur.model';

export class IndigroupModel
{
	id: number = undefined;
	name: string = undefined;
	description: string = undefined;

	indicators:Array<IndicateurModel> = [];


	constructor(values: Object) {
	   this.exchange(values);
	}
	exchange(values: Object = {}) {
	    for (let p in values) {
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else if(p=='indicators') {
		    		values[p].forEach((i)=>{
		    			this.indicators[i.ordre] = new IndicateurModel(i);
		    		});
		    	}
		    	else {
		    		this[p] = values[p];
		    	} 
		    }
		  }
	}


	get answersInfos()
	{
		let completed:number = 0;
		let completedAndNotable:number = 0;
		let uncompleted:number = 0;
		let score:number = 0;
		let pondNbAnswers:number = 0;
		let pondScore:number = 0;
		this.indicators.forEach((indicator:IndicateurModel)=>{
			if(indicator.answer.completed) {
				completed++;
				if(indicator.multichoicegravity!=-10) {
					completedAndNotable++;
					pondNbAnswers += indicator.answer.revelent;
					score += (indicator.answer.finalScore * 1);	//*1 : hack to fix integers+float sum bug (1.00+2 = "1.002")
					pondScore += (indicator.answer.finalScore * indicator.answer.revelent);
				}
			} else uncompleted++;

		});

		return {
			completed: completed,
			completedAndNotable: completedAndNotable,
			uncompleted: uncompleted,
			score: score,
			pondNbAnswers: pondNbAnswers,
			pondScore: pondScore,
		};
	}
}